import { SHOWROOM_PATH_IDENTIFIER } from "@faire/deprecated-retailer-visitor-shared/categories/pathIdentifier";
import { ImageTextLinkTile } from "@faire/deprecated-retailer-visitor-shared/components/Carousel/ImageTextLinkTile";
import { categoryPath } from "@faire/deprecated-retailer-visitor-shared/paths/category/categoryPath";
import { useRetailerRoutingContext } from "@faire/deprecated-retailer-visitor-shared/RetailerRoutingContextProvider";
import { findClosestActiveCategoryUrlIdsByPathIdentifier } from "@faire/deprecated-retailer-visitor-shared/stores/domain/CategoryStore/findByPathIdentifier";
import { useCategoryStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useCategoryStore";
import { isNotUndefined } from "@faire/typescript";
import { ICategoryTile } from "@faire/web-api--source/indigofair/data/ICategoryTile";
import React from "react";

interface IImageSizeInfo {
  height: number;
  width: number;
}

interface IProps {
  categoryTile: ICategoryTile;
  imageSizeInfo: IImageSizeInfo;
  handleStyledLinkOnClick?: () => void;
  dataTestId?: string;
  className?: string;
}

export const AnimatedCategoryTile: React.FC<IProps> = ({
  categoryTile,
  handleStyledLinkOnClick,
  imageSizeInfo,
  dataTestId,
  className,
}) => {
  const { categories } = useCategoryStore();
  const routingContext = useRetailerRoutingContext();
  if (
    !categoryTile ||
    !(categoryTile.image || categoryTile.images.length > 0) ||
    !categoryTile.name ||
    !categoryTile.category_path_identifier
  ) {
    return null;
  }

  const isShowroom = categoryTile.category_path_identifier.includes(
    SHOWROOM_PATH_IDENTIFIER
  );

  let path = "";
  if (isNotUndefined(categoryTile.cta_link)) {
    path = categoryTile.cta_link;
  } else if (categoryTile.category_path_identifier) {
    const categoryUrlIds = findClosestActiveCategoryUrlIdsByPathIdentifier(
      categoryTile.category_path_identifier,
      categories
    );
    if (categoryUrlIds === undefined) {
      return null;
    }
    path = categoryPath({ urlIds: categoryUrlIds, routingContext });
  }

  return (
    <ImageTextLinkTile
      keyString={categoryTile.category_path_identifier}
      link={path}
      parentCategoryName={categoryTile.parent_category_name}
      text={categoryTile.name}
      image={categoryTile.image}
      imageSizeInfo={imageSizeInfo}
      handleStyledLinkOnClick={handleStyledLinkOnClick}
      dataTestId={dataTestId}
      className={className}
      useShowroomAnimatedTile={isShowroom}
      images={categoryTile.images}
    />
  );
};
